<p-toast></p-toast>
<div class="map-wrapper">
  <div #mapContainer class="map-container" [style.height]="height">
    <div class="map-loading" *ngIf="!mapLoaded">
      <i class="pi pi-spin pi-spinner"></i>
      <span style="color: #0B0C0E">{{ 'Loading' | translate }}</span>
    </div>
    <div class="map-loading" *ngIf="isLoading">
      <i class="pi pi-spin pi-spinner"></i>
    </div>
  </div>


  <!-- Copy parent control (was with undo) -->
  <div class="undo-control flex flex-column justify-content-end align-content-end gap-1" *ngIf="showCopyParentBtn">
    <app-secondary-button
      title="{{showCopyParentContourLabel}}"
      (click)="copyParentPolygon()"
      icon="pi pi-copy"
    >
    </app-secondary-button>
  </div>


  <div class="right-controls">
    <div class="zoom-controls" *ngIf="zoomControl">
        <span
          class="cursor-pointer"
          (click)="zoomIn()"
          [pTooltip]="'Zoom In' | translate"
        >
          <i class="pi pi-plus"></i>
        </span>
      <span
        class="cursor-pointer"
        (click)="zoomOut()"
        [pTooltip]="'Zoom Out' | translate"
      >
          <i class="pi pi-minus"></i>
        </span>
    </div>
    @if (isCenterControl) {
      <button
        pButton
        class="p-button-rounded p-button-text" [pTooltip]="'Center Map' | translate" tooltipPosition="top"
        [class.active]="drawingMode"
        (click)="centerMap()"
      >
        <img
          [src]="'map-center' | iconPath"
          alt="Map"
          class="map-icon"
        />
      </button>
    }

  </div>

  @if (showControls || showPolygonFillToggle) {
    <div class="map-drawing-controls">
      <div class="drawing-controls-container flex-row">

        @if (showControls) {
          <button
            class="draw-btn"
            (click)="stopPolygonDrawing();startPolygonDrawing()"
            [title]="'DRAW_POLYGON' | translate">
            <img src="assets/icons/main/light/sixers.svg" width="20" height="20" alt="Polygon">
          </button>

          @if (isSplitControl) {
            <button
              class="draw-btn"
              [title]="'Split Polygon' | translate"
              (click)="splitMode ? deactivateSplitMode() : activateSplitMode()"

              style="margin-left: 8px;">
              <img
                [src]="'scissors' | iconPath"
                alt="Split"
                class="map-icon"
              />
            </button>
          }

          @if (hasSplit) {
            <button
              class="draw-btn"
              [title]="'Switch' | translate"
              (click)="swapSplitIds()"
              style="margin-left: 8px;">
              <i class="pi pi-arrows-h" style="font-size: 18px;"></i>
            </button>
          }


          <button
            class="draw-btn"
            (click)="stopPolygonDrawing(); geometryChange.emit(null)"
            [title]="'Clear All Drawings' | translate"
            style="margin-left: 8px;">
            <img src="assets/icons/main/light/eraser.svg" width="20" height="20" alt="Clear All">
          </button>

          @if ((canUndo || hasSplit)) {
            <button
              class="draw-btn"
              (click)="undo()"
              [disabled]=""
              [title]="(hasSplit ? 'Restore' : 'Undo') | translate">
              <i class="pi pi-undo" style="font-size: 18px;"></i>
            </button>
          }
        }

        @if (showPolygonFillToggle) {
          <div class="polygon-fill-tool-wrapper" [style.margin-left]="showControls ? '8px' : '0'">
            <button
              type="button"
              class="draw-btn"
              [class.active]="polygonFillMenuOpen"
              (click)="togglePolygonFillMenu($event)"
              [title]="'MAP_VISIBILITY.TOOL_TITLE' | translate">
              <i class="pi pi-eye" style="font-size: 18px;"></i>
            </button>
            @if (polygonFillMenuOpen) {
              <div class="polygon-fill-popover" (click)="$event.stopPropagation()">
                <app-checkbox
                  [ngModel]="polygonFillVisible"
                  (ngModelChange)="setPolygonFillVisible($event)"
                  [label]="'MAP_VISIBILITY.FILL_POLYGONS'"
                  size="medium"
                  color="primary"
                ></app-checkbox>
              </div>
            }
          </div>
        }

      </div>

      @if (showIndexControl && hasActiveIndexLayer) {
        <div class="map-index-opacity">
          <span class="opacity-icon"><i class="pi pi-sun"></i></span>
          <input
            type="range"
            min="0"
            max="100"
            [ngModel]="indexLayerOpacityPercent"
            (ngModelChange)="onIndexOpacityChange($event)"
            class="opacity-slider">
          <span class="opacity-value">{{ indexLayerOpacityPercent }}%</span>
        </div>
      }
    </div>
  }

  <div class="map-switcher-control flex flex-row gap-2 align-items-start">
    <div class="layer-switcher-container">
      <button
        class="layer-btn"
        [class.active]="isPlanLayerActive"
        (click)="selectPlanLayer()"
        [title]="'PLAN' | translate">
        <span>{{ 'PLAN' | translate }}</span>
      </button>

      <div class="satellite-btn-wrapper">
        <button
          class="layer-btn satellite-main-btn"
          [class.active]="!isPlanLayerActive"
          [title]="currentSatelliteLabel | translate"
          (click)="satelliteSelectorVisible = !satelliteSelectorVisible">
          <span>{{ currentSatelliteLabel | translate }}</span>
          <i class="pi pi-chevron-up"></i>
        </button>
        <app-satellite-style-selector
          [styles]="satelliteMenuItems"
          [selected]="isPlanLayerActive ? null : currentBaseLayer"
          [visible]="satelliteSelectorVisible"
          (select)="selectSatelliteLayer($event)"
          (close)="satelliteSelectorVisible = false"
        ></app-satellite-style-selector>
      </div>
    </div>

    @if (showIndexControl) {
      <div class="index-control-button">
        <app-secondary-button
          (click)="openIndexModal()"
          [title]="'INDEX_TILE_MAP.INDEXES'"
          [icon]="'pi pi-images'"
        ></app-secondary-button>
      </div>
    }
  </div>
  <!-- Draw Control -->

  @if (showIndexControl) {
    <p-dialog
      [(visible)]="showIndexModal"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '520px' }"
      [header]="'INDEX_TILE_MAP.INDEX' | translate"
      (onHide)="closeIndexModal()">
      <div class="index-modal-form">
        <msf-select
          class="index-select"
          [(model)]="selectedIndexLayer"
          [options]="indexLayerOptions"
          optionLabel="names"
          optionValue="value"
          [placeholder]="'Select layer' | translate"
          [showClear]="true"
          (modelChange)="onIndexLayerChange($event)">
        </msf-select>

        <app-date-picker
          class="index-date"
          [(ngModel)]="selectedIndexDate"
          [placeholder]="'Select date' | translate"
          [selectableDates]="indexAvailableDates ?? null"
          [allowOnlySelectedDate]="true"
          (ngModelChange)="onIndexDateChange($event)"
          (onYearChange)="getAvailableIndexDates($event)">
        </app-date-picker>

        <div class="index-modal-actions">
          <button
            class="display-btn"
            pButton
            type="button"
            label="{{ 'Show' | translate }}"
            [disabled]="!(selectedIndexLayer && selectedIndexDate)"
            (click)="applyIndexSelection()">
          </button>
        </div>
      </div>
    </p-dialog>
  }

</div>
